<template>
  <div class="dm_detail_card">
    <!--<div class="question_mask"></div>-->
    <div>
      <FormPreview :exam="question" />
    </div>
  </div>
</template>

<script>
  import FormPreview from '@/views/i-surveys/views/form/preview'
  export default {
    name: 'WorkDmDetailQuestion',
    components: { FormPreview },
    props: {
      detail: {
        type: Object,
        default: () =>({})
      }
    },
    computed: {
      question () {
        if (!this.detail) return []
        if (!this.detail.content) return []
        return JSON.parse(this.detail.content).map(item => ({
			...item,
			// 中药项目的问卷，需要去掉（请输入至少20个字符）
			name: this.detail.projectId === '1774972748455157762' ? item.name.replace('（请输入至少20个字符）', '') : item.name
		}))
      }
    }
  }
</script>

<style lang="less" scoped>
.dm_detail_card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  padding: 10px 0;
  background-color:#FFF;
  .question_mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }
}
</style>
